




























import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import {AxiosPromise, CancelTokenSource} from 'axios';
import EquipmentTable from '@/components/specific/EquipmentsTable/EquipmentTable.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
@Component({
    components: {CTextField, CEditDialog, EquipmentTable},
})
export default class EquipmentSettingsEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        Name: 'Name',
    };
    private rows: any = null;
    private equipmentDictionary: any = null;

    getEquipmentTypeDescriptions() {
        return this.$http.get(`${this.$api.catalogues.equipmentType}/GetDescriptions`);
    }

    async openAsync(request: AxiosPromise, cancelRequest: CancelTokenSource, options: any) {
        this.dialog = true;
        this.cancelRequest = cancelRequest;
        this.options = options;
        const timerId = setTimeout(() => {
            this.loading = true;
        }, 100);
        try {
            const [{data}, {data: equipmentType}] = await Promise.all([request, this.getEquipmentTypeDescriptions()]);
            this.equipmentDictionary = new Map();
            equipmentType.forEach((type: any) => {
                this.equipmentDictionary.set(type.Id, type.Description);
            });
            this.rows = [];
            data.ElementList.forEach((model: any, index: number) => {
                model.Name = this.equipmentDictionary.get(model.IdEquipmentType);
                this.rows.push({showDetail: false, ref: `detail-${index}`});
            });
            this.data = data;
        } catch (err) {
            console.log(err);
            this.close();
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    save() {
        const form = this.$refs.form as any;
        if (!form) {
            console.warn('form ref not found at validation state');
        }
        const mainFormValidation = form.validate();
        if (mainFormValidation) {
            if (typeof this.options.saveCallback == 'function') {
                this.saving = true;
                this.options.saveCallback(this.data);
            } else {
                console.warn('no saveCallback provided');
                this.close();
            }
        }
    }
}
